// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-aster -> weidner-apartment-homes-aster -> uptown-at-kirkland-urban
// Generated: 2026-11-03T00:32:08.868Z
// Counts: 2 design, 63 content, 21 slot group, 1 collection binding, 8 section, 0 style

export const designOverrides = {
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#707070",
    "mappedField": null
  },
  "design.SpecialOfferBanner.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Accessibility</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_amenities_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Amenities</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Amenities</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.intro": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to a world of unmatched luxury and convenience at <span data-type=\"field-token\" data-field=\"property_name\"></span>. Our amenity offerings redefine the standard of modern living, providing an exquisite backdrop to complement your lifestyle.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.interiorHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Apply Now</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_contactus_blurb"
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Contact Us</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "conveniencecallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "conveniencecallout.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Convenience All Around</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_floorplans_blurb"
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Floor Plans</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.feature_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.feature_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Spacious Apartment Homes</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.contact_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Contact</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.follow_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Follow Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.office_hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Office Hours</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.visit_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Visit Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_gallery_blurb"
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Gallery</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Discover dog-friendly apartments in Meridian, Idaho. Enjoy pet-friendly living spaces tailored for you and your furry friends.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Dog-Friendly Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Interactive Map</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Have questions about how to start living at your new home? Our dedicated leasing team at <span data-type=\"field-token\" data-field=\"property_name\"></span> is here to assist you.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Let's Connect</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_neighborhood_blurb"
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Neighborhood</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Pet Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyinfo.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.info": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.restrictions": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "petpolicyinfo.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Privacy Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_long_description"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Luxury Apartment Living</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_residentaccess_blurb"
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Resident Access</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.help_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Need Help? Call Us</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.portal_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resident Portal</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Schedule A Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Sitemap</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "testimonials.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Testimonials</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Thank You</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Virtual Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "dallasmavericksgames.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Go Mavs, Go <span data-type=\"field-token\" data-field=\"property_name\"></span>!</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "deals-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>CORT Furniture Rental</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "future-residents-club-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Future Residents Club</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "conveniencecallout.background": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "conveniencecallout.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.feature_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "letsconnect.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[23].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[23].image_media.alt_text"
      }
    }
  },
  "conveniencecallout.feature_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[6].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[6].image_media.alt_text"
      }
    }
  },
  "floorplanslist.feature_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[25].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[25].image_media.alt_text"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image_media.alt_text"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[28].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[28].image_media.alt_text"
      }
    }
  },
  "photoslider.slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-5840-73ce-b303-038c05859e11.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern multi-story apartment building with balconies and a landscaped courtyard."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Modern Building Exterior"
      }
    }
  },
  "photoslider.slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-5023-72a9-b68f-ecc7d728c7d9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop terrace with string lights, seating areas, a fire pit, and a foosball table."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop Lounge"
      }
    }
  },
  "photoslider.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-31c1-7078-962b-e992ce338fe9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior lounge with blue sectional sofas, a large bookshelf wall, and a reception desk with people present."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resident Lounge"
      }
    }
  },
  "photoslider.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-6770-70eb-a4dd-974f7e4d9152.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior view of a modern kitchen with an island, bar seating, and stainless steel appliances."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Chef-Inspired Kitchen"
      }
    }
  },
  "photoslider.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-47b1-71dc-a890-939a7296941d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Contemporary apartment courtyard with outdoor seating and a person walking along a path."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Landscaped Courtyard"
      }
    }
  },
  "photoslider.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-294b-73c5-867b-c9f5160917aa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment gym with treadmills, free weights, weight machines, and a large window wall."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[5].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[5].image_media.alt_text"
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photoslider.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      2,
      3,
      7,
      11,
      10,
      9
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      22,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
